import { INVENTORY_PLATFORMS } from "./agent-platform"

import type { AgentSourceAi } from "./agent-source.types"

export const AGENT_SOURCES: AgentSourceAi[] = [
  ...INVENTORY_PLATFORMS,
  "PROJECT"
]

export const isAgentSource = (value: string): value is AgentSourceAi =>
  AGENT_SOURCES.some((source) => source === value)
